import * as types from '../actionType'

const initialState = []

const sellerOrderDetails = (state = initialState, action) => {
    switch (action.type) {
        case types.SELLER_GET_ORDERS_DETAILS:
            return action.payload
        default:
            return state
    }
}


export { sellerOrderDetails }